// Shared page-header "eyebrow" chip — the canonical replacement for the
// byte-identical inline `Eyebrow: {...}` block forked across cap-table/cms/
// catalog/polyglot/helmet (workspace/DESIGN_LANGUAGE.md §8.5 rule 3: "hue
// carries in the wash; ink stays neutral"). Measured 2026-08-08, light theme,
// hue ink over hue.15 wash over the page ground (rgb(241,241,243)):
//   green  → 2.20:1  FAIL  (cap-table, helmet)
//   blue   → 2.70:1  FAIL  (cms)
//   orange → 2.12:1  FAIL  (polyglot)
//   purple → 4.70:1  pass  (catalog)
// Four of five forks failed WCAG AA (3:1 large-text floor) by painting the
// brand hue as TEXT on a translucent wash of the SAME hue — the wash
// composites toward near-white on light grounds regardless of which hue it
// is, so the "passing" purple copy was luck, not a safe pattern. Do NOT
// revert this back to a hue-coloured `color` — put the hue back in the wash
// and it fails again.
//
// This component owns ONLY the invariant geometry + the neutral ink. It
// deliberately does NOT own the hue: a factory-resolved `color` token is a
// known trap in this codebase (see MEMORY.md
// project_static_color_token_table_drop — static `color` is resolved once
// against the token table, so per-instance hue would need an (el, s)
// function anyway). Keeping `background` a plain per-consumer prop sidesteps
// that trap entirely and keeps the hue where §8.5 says it belongs: in the
// wash, supplied by each app.
//
// Usage:
//   AppPageEyebrow: { background: 'green.15', text: 'Cap table' }
export const AppPageEyebrow = {
  tag: 'span',
  fontSize: 'Y2',
  fontWeight: '500',
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: 'title',
  padding: 'V Z',
  round: 'radiusPill'
}
